import React from "react";
import PropTypes from "prop-types";
import { ReactComponent as WarningIcon } from "images/profile/warning-icon.svg";

function Warning({ message = "", className = "" }) {
  return (
    <div
      className={`flex lg-max:flex-col py-[14px] px-[16px] text-[#1D1B22] text-[14px] lg-max:justify-start lg-max:gap-[10px] items-center lg-max:items-start self-stretch rounded-[8px] bg-[#FEF3F2] gap-[10px] ${className}`}
    >
      <WarningIcon />
      {message}
    </div>
  );
}

Warning.propTypes = {
  message: PropTypes.string,
  className: PropTypes.string,
};

export default Warning;
